//Modal shown when mint button is pressed by issuer. When issuer enters amount to be minted the mint API is called.
import React, { useState, ChangeEvent, useEffect, useCallback } from 'react';
import {
  makeStyles,
  Theme,
  createStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  CircularProgress,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { sellBolt } from '../../redux/actions/boltAction';
import ActionButton from '../common/ActionButton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    boltViewPaper: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.secondary.main,
      minHeight: '500px',
      minWidth: '400px',
      alignItems: 'center',
      padding: 10,
    },
    boltViewContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    },
    buttonSection: {
      display: 'flex',
      alignItems: 'center',
      position: 'absolute',
      justifyContent: 'center',
      bottom: 0,
      paddingBottom: 20,
      width: '100%',
    },
    actionButton: {
      margin: 5,
      padding: '10px 15px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      transition: 'background-color 0.5s',
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: theme.palette.grey[200],
      },
    },
    textFieldStyle: {
      width: 300,
      display: 'block',
    },
  })
);

//Type of the props
type SELLBOLTS = {
  setDialogOpen: (isOpen: boolean) => void;
  handleBack: () => void;
  specID: string;
};

// FIXLATER
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function SellBolt(props: SELLBOLTS) {
  const classes = useStyles();
  const [amount, setAmount] = useState('');
  const [email, setEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [amountValid, setAmountValid] = useState(true);
  const [emailValid, setEmailValid] = useState(true);
  const setDialogOpen = props.setDialogOpen;
  const handleBack = props.handleBack;
  const specID = props.specID;
  const dispatch = useDispatch();
  const [isSelling, setIsSelling] = React.useState<boolean | null>(null);

  //Close the dialog
  const handleClose = useCallback(() => {
    setDialogOpen(false);
  }, [setDialogOpen]);

  //Handles input amount
  const handleAmountChange = (e: ChangeEvent<HTMLInputElement>) => {
    setAmount(e.target.value);
    if (isNaN(Number(e.target.value))) {
      setAmountValid(false);
    } else {
      setAmountValid(true);
    }
  };

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleConfirmEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setConfirmEmail(e.target.value);
    if (e.target.value !== email) {
      setEmailValid(false);
    } else {
      setEmailValid(true);
    }
  };

  // Handles the submit button and calls the service to mint bolt
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsSelling(true);
    dispatch(sellBolt(specID, Number(amount), setIsSelling, email));
  };

  useEffect(() => {
    if (isSelling === false) {
      handleClose();
    }
  }, [isSelling, handleClose]);

  return (
    <Dialog
      classes={{
        paper: classes.boltViewPaper,
      }}
      open={true}
      onClose={handleClose}
      maxWidth={'md'}
    >
      <DialogTitle id="form-dialog-title">Sell ZUZ</DialogTitle>
      <DialogContent className={classes.boltViewContent}>
        <form onSubmit={handleSubmit}>
          <TextField
            className={classes.textFieldStyle}
            required
            variant="outlined"
            color="secondary"
            margin="normal"
            fullWidth
            id="amount"
            label="Amount"
            name="amount"
            autoFocus
            value={amount}
            onChange={handleAmountChange}
            error={!amountValid}
            helperText={amountValid ? '' : 'Amount entered is invalid'}
            disabled={isSelling === true}
          />
          <TextField
            className={classes.textFieldStyle}
            required
            variant="outlined"
            color="secondary"
            margin="normal"
            fullWidth
            id="email"
            label="E-Mail"
            name="email"
            value={email}
            onChange={handleEmailChange}
            disabled={isSelling === true}
          />
          <TextField
            className={classes.textFieldStyle}
            required
            variant="outlined"
            color="secondary"
            margin="normal"
            fullWidth
            id="email"
            label="Confirm E-Mail"
            name="email"
            value={confirmEmail}
            error={!emailValid}
            helperText={emailValid ? '' : "E-Mails entered don't match"}
            onChange={handleConfirmEmailChange}
            disabled={isSelling === true}
          />
        </form>
        {isSelling && (
          <div style={{ textAlign: 'center' }}>
            <div>Please wait as we confirm your transaction...</div>
            <CircularProgress />
          </div>
        )}
      </DialogContent>
      <ActionButton
        handleCallback1={handleBack}
        handleCallback2={handleSubmit}
        name1="Back"
        name2="Submit"
        disabled2={!amountValid || !emailValid || confirmEmail.length <= 0}
      />
    </Dialog>
  );
}

export default SellBolt;
